<template>
  <section class="summary-section">
    <container>
      <div class="col-sm-12 col-md-6">
        <h2>จำนวนเลือดที่มีในระบบ</h2>
        <bar-chart-horizontal class="bar-chart-horizontal" :bloodData="summaryBloodDistrubution"/>
        <p>
          รู้หรือไม่<br/>
          สัตว์เลี้ยงมีความต้องการเลือด<br/>
          เฉลี่ยเดือนละ 1,650 units
        </p>
        <router-link :to="{ name: 'donation'}" class="btn btn-secondary cta">ร่วมบริจาคเลือด</router-link>
      </div>
      <div class="col-sm-12 col-md-6 d-none d-md-block">
        <img class="blood-bag" src="@/assets/other/blood-bag.png" alt="Blood bag">
      </div>
    </container>
  </section>
</template>

<script>
import Container from '@/components/Container.vue'
import BarChartHorizontal from '@/components/BarChartHorizontal.vue'

export default {
  name: 'SummarySection',
  data () {
    return {
      bloodCollection: this.$store.bloodCollection,
      summaryBloodDistrubution: [
        {
          type: 'สุนัข',
          units: 0,
          barWidth: 0
        },
        {
          type: 'แมว',
          units: 0,
          barWidth: 0
        }
      ]
    }
  },
  mounted () {
    var validBloodCollection = this.$store.getters.getValidBloodCollection
    if (validBloodCollection.length === 0) {
      this.$store.dispatch('getBloodCollectionData').then(() => {
        this.updateBloodCollection()
      })
    } else {
      this.updateBloodCollection()
    }
  },
  methods: {
    updateBloodCollection () {
      var validBloodCollection = this.$store.getters.getValidBloodCollection
      this.summaryBloodDistrubution[0].units = validBloodCollection.filter(
        bag => bag.pet_type.toLowerCase().indexOf('dog') !== -1
      ).length
      this.summaryBloodDistrubution[1].units = validBloodCollection.filter(
        bag => bag.pet_type.toLowerCase().indexOf('cat') !== -1
      ).length
    }
  },
  components: {
    Container,
    BarChartHorizontal
  }
}
</script>

<style scoped lang="scss">
.summary-section {
  padding: 2rem 0;
  background: linear-gradient(#f5515f, #9f041b);
  color: white;
  overflow: hidden;
  h2 {
    font-size: $h3-font-size;
    text-align: center;
  }
  p {
    font-weight: $font-weight-light;
    font-size: $h5-font-size;
  }
  .blood-bag {
    width: 200px;
    position: absolute;
    top: 0;
    right: 5rem;
  }
  .bar-chart-horizontal {
    margin: 1rem 0;
  }
}
@media (min-width: map-get($grid-breakpoints, "sm")) {
  .summary-section {
    padding: 2.5rem 0;
    h2 {
      font-size: $h2-font-size;
    }
    p {
      font-size: $h3-font-size;
    }
    .bar-chart-horizontal {
      margin: 2rem 0;
    }
  }
}
</style>
